import React, { useState } from "react";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import "../../App.css";

import { Col, Row, Image, Divider } from "antd";

import { ParagraphHeader } from "@seims/shared";
import ProgrammeSubscription from "../programme/ProgrammeSubscription";
import { programmes } from "../../utils/apiConstants";

const VolunteerScientistView = () => {
  const [visible, setVisible] = useState(false);

  const programme = programmes.find((p) => p.key === "volunteer-scientist");

  const showModal = (value) => {
    setVisible(value);
  };

  return (
    <>
      <ParagraphHeader header="Volunteer Scientist" />
      <Row>
        <Col xs={24}>
          <div className="center-align">
            <p>
              A paragraph is defined as “a group of sentences or a single
              sentence that forms a unit” (Lunsford and Connors 116). Length and
              appearance do not determine whether a section in a paper is a
              paragraph. For instance, in some styles of writing, particularly
              journalistic styles, a paragraph can be just one sentence long.
            </p>
            <Image
              src={require("../../assets/scientists-programme.png")}
              alt="Volunteer Scientist"
            />
          </div>
        </Col>
      </Row>
      <Divider />
      {/* <ProgrammeSubscription programme={programme} showButton={true} /> */}
    </>
  );
};

export default VolunteerScientistView;
